import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AvalancheReelsView} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsView';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';

export class AvalancheReelsInitState extends ModuleState<AvalancheReelsView, AvalancheReelsModule> {
	public onEnterState(): void {
	}

	public onLeaveState(): void {
	}

	protected setupEvents(): void {

		this.on(LogicEvents.INIT_RESPONSE, this.onInitResponse);
	}

	protected onInitResponse(): void {
		this.module.gotoState(AvalancheReelsModule.BASIC_STATE);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheReelsInitState.ts